export const numberToMoney = (value: number | undefined | null, currency = 'R$ '):
  string => `${currency}${value ? value.toFixed(2) : (0).toFixed(2)}`.replace('.', ',');
